import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { LayoutComponent } from "./layout/layout.component";
import { AuthGuard } from "./helpers/auth.guard";
import { InvoiceComponent } from "./customer/invoice/invoice.component";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "invoice",
    component: InvoiceComponent,
  },
  {
    path: "register",
    loadChildren: () =>
      import("./pages/authentication/register/register.module").then(
        (m) => m.RegisterModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "forgot-password",
    loadChildren: () =>
      import("./pages/authentication/forgot-password/forgot-password.module").then(
        (m) => m.ForgotPasswordModule,
      ),
  },
  {
    path: "coming-soon",
    loadChildren: () =>
      import("./pages/coming-soon/coming-soon.module").then(
        (m) => m.ComingSoonModule,
      ),
    canActivate: [AuthGuard],
  },

  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "athlete",
        loadChildren: () =>
          import("./athlete/athlete.model").then((m) => m.AthleteModel),
        canActivate: [AuthGuard],
      },
      {
        path: "customers",
        loadChildren: () =>
          import("./customer/customer.module").then((m) => m.CustomerModule),
        canActivate: [AuthGuard],
      },
      {
        path: "",
        loadChildren: () =>
          import("./pages/dashboard/dashboard.module").then(
            (m) => m.DashboardModule,
          ),
        pathMatch: "full",
        canActivate: [AuthGuard],
      },
      {
        path: "apps/inbox",
        loadChildren: () =>
          import("./pages/apps/inbox/inbox.module").then((m) => m.InboxModule),
        canActivate: [AuthGuard],
      },
      {
        path: "apps/calendar",
        loadChildren: () =>
          import("./pages/apps/calendar/calendar.module").then(
            (m) => m.CalendarAppModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "apps/chat",
        loadChildren: () =>
          import("./pages/apps/chat/chat.module").then((m) => m.ChatModule),
        canActivate: [AuthGuard],
      },
      {
        path: "components",
        loadChildren: () =>
          import("./pages/components/components.module").then(
            (m) => m.ComponentsModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "forms/form-elements",
        loadChildren: () =>
          import("./pages/forms/form-elements/form-elements.module").then(
            (m) => m.FormElementsModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "forms/form-wizard",
        loadChildren: () =>
          import("./pages/forms/form-wizard/form-wizard.module").then(
            (m) => m.FormWizardModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "icons",
        loadChildren: () =>
          import("./pages/icons/icons.module").then((m) => m.IconsModule),
        canActivate: [AuthGuard],
      },
      {
        path: "page-layouts",
        loadChildren: () =>
          import("./pages/page-layouts/page-layouts.module").then(
            (m) => m.PageLayoutsModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "tables/all-in-one-table",
        loadChildren: () =>
          import("./pages/tables/all-in-one-table/all-in-one-table.module").then(
            (m) => m.AllInOneTableModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "drag-and-drop",
        loadChildren: () =>
          import("./pages/drag-and-drop/drag-and-drop.module").then(
            (m) => m.DragAndDropModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "editor",
        loadChildren: () =>
          import("./pages/editor/editor.module").then((m) => m.EditorModule),
        canActivate: [AuthGuard],
      },
      {
        path: "blank",
        loadChildren: () =>
          import("./pages/blank/blank.module").then((m) => m.BlankModule),
        canActivate: [AuthGuard],
      },
      {
        path: "level1/level2/level3/level4/level5",
        loadChildren: () =>
          import("./pages/level5/level5.module").then((m) => m.Level5Module),
        canActivate: [AuthGuard],
      },
      { path: "**", redirectTo: "" },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: "enabledNonBlocking",
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
